import React, { useContext } from "react";
import { observer } from "mobx-react";

import CashoutProcessButton from "./CashoutProcessButton";
import CashoutConfirmationForm from "./CashoutConfirmationForm";
import CashoutMessageModal from "./CashoutMessageModal";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { useRootAppStore } from "@hooks";

export default observer(function BetItemCashout() {
	const bet = useContext(MyBetsBetContext);
	const store = useRootAppStore().myBetsViewStore;

	if (bet.isCashoutUnavailable) {
		return null;
	}

	if (
		store.cashoutStore.isCashoutModalOpen &&
		store.cashoutStore.cashoutModalData?.id === bet.id
	) {
		if (store.cashoutStore.cashoutModalData.message != null) {
			return <CashoutMessageModal store={store.cashoutStore} />;
		}
		return <CashoutConfirmationForm store={store.cashoutStore} />;
	}

	return <CashoutProcessButton store={store.cashoutStore} />;
});
